@if (policyForm) {
	<div>
		<div class="d-flex">
			<div class="colstat colstat-big">
				<label>{{ "name" | langVal }}</label>
				<app-gen-input
					tabindex="1"
					[actualObj]="policyForm"
					[errors]="errors"
					[isStatic]="policyForm?.is_documented"
					fieldName="name"
					autofocus="autofocus"
					(changeEvent)="validateAndSave('name')"
				>
				</app-gen-input>
			</div>
		</div>
		<div class="d-flex">
			<div class="colstat-big">
				<label>{{ "person_types" | langVal }}</label>
				<app-autocomplete-multi
					[optionValuesArray]="['patient', 'contact', 'payor', 'user']"
					[ids]="policyForm.person_types"
					(addItem)="onPersonTypesAdd($event)"
					(deleteItem)="onPersonTypesDelete($event)"
					[isStatic]="policyForm?.is_documented"
				/>
			</div>
		</div>
		<div>
			<app-gen-button-group
				[actualObj]="policyForm"
				fieldName="sign_required"
				optionsListName="sign_required_opts"
				(changeEvent)="validateAndSave('sign_required')"
			/>
		</div>
	</div>
	@if (!policyForm.id) {
		<div class="mt-5">
			<app-btn-ext
				text="policy_form_insert"
				[disabled]="!isFormSubmittable"
				(clickEv)="save()"
				[isSpin]="isSaving"
			/>
		</div>
	}
	@if (policyForm.id) {
		<versions [objectRow]="policyForm" />
	}

	<div class="modal-btns">
		<app-btn-ext
			text="exit"
			(clickEv)="onClose.emit()"
		/>
	</div>
}
